var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoMain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3954.1 1080",
    style: {
      enableBackground: "new 0 0 3954.1 1080"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:url(#SVGID_1_);}\n\t.st2{fill:#08203E;}\n\t.st3{fill:#557C93;}\n\t.st4{fill:url(#SVGID_00000073717709757482282120000006930520792529130431_);}\n\t.st5{fill:#43413F;}\n\t.st6{fill:#BCBEC0;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1334.4,323.5v87.1h-118.2v359.1h-108.7V410.6H989.3v-87.1H1334.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1704.9,451.6c24.6,26.9,36.9,63.9,36.9,110.9v207.2h-108V577.1c0-23.7-6.1-42.2-18.4-55.3 c-12.3-13.1-28.8-19.7-49.6-19.7c-20.8,0-37.3,6.6-49.6,19.7c-12.3,13.1-18.4,31.6-18.4,55.3v192.6h-108.7V299.4h108.7v163.3 c11-15.7,26.1-28.2,45.1-37.5c19.1-9.3,40.5-14,64.2-14C1647.7,411.2,1680.3,424.7,1704.9,451.6z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2149.8,618.4h-245.9c1.7,22,8.8,38.9,21.3,50.5c12.5,11.7,27.9,17.5,46.1,17.5c27.1,0,46-11.4,56.6-34.3h115.7 c-5.9,23.3-16.6,44.3-32.1,62.9c-15.5,18.6-34.9,33.3-58.2,43.9c-23.3,10.6-49.4,15.9-78.2,15.9c-34.7,0-65.7-7.4-92.8-22.2 c-27.1-14.8-48.3-36-63.6-63.6c-15.2-27.5-22.9-59.7-22.9-96.6c0-36.9,7.5-69,22.6-96.6c15-27.5,36.1-48.7,63.2-63.5 c27.1-14.8,58.2-22.2,93.4-22.2c34.3,0,64.8,7.2,91.5,21.6c26.7,14.4,47.6,34.9,62.6,61.6c15,26.7,22.6,57.8,22.6,93.4 C2151.7,596.8,2151,607.4,2149.8,618.4z M2040.5,558c0-18.6-6.4-33.5-19.1-44.5c-12.7-11-28.6-16.5-47.7-16.5 c-18.2,0-33.6,5.3-46.1,15.9c-12.5,10.6-20.2,25.6-23.2,45.1H2040.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M2365.2,428.1c19.1-11.2,40.2-16.8,63.6-16.8v115h-29.9c-27.1,0-47.5,5.8-61,17.5 c-13.6,11.7-20.3,32.1-20.3,61.3v164.6h-108.7V415h108.7v59.1C2330.2,454.6,2346.1,439.3,2365.2,428.1z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M2479.9,495.7c13.8-27.5,32.5-48.7,56.2-63.5c23.7-14.8,50.2-22.2,79.4-22.2c25,0,46.9,5.1,65.8,15.2 c18.8,10.2,33.4,23.5,43.5,40V415h108.7v354.6h-108.7v-50.2c-10.6,16.5-25.3,29.9-44.2,40c-18.9,10.2-40.8,15.3-65.8,15.3 c-28.8,0-55.1-7.5-78.8-22.6c-23.7-15-42.5-36.4-56.2-64.2c-13.8-27.7-20.7-59.8-20.7-96.3C2459.2,555.3,2466.1,523.3,2479.9,495.7z  M2702.3,528.2c-15-15.7-33.4-23.5-55-23.5s-39.9,7.7-55,23.2c-15,15.5-22.6,36.8-22.6,63.9c0,27.1,7.5,48.6,22.6,64.5 c15,15.9,33.4,23.8,55,23.8s39.9-7.8,55-23.5c15-15.7,22.6-37.1,22.6-64.2C2724.9,565.2,2717.4,543.8,2702.3,528.2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3064.9,425.2c18.6-10.2,40.5-15.2,65.5-15.2c29.2,0,55.7,7.4,79.4,22.2c23.7,14.8,42.5,36,56.2,63.5 c13.8,27.6,20.6,59.5,20.6,96c0,36.5-6.9,68.5-20.6,96.3c-13.8,27.8-32.5,49.2-56.2,64.2c-23.7,15-50.2,22.6-79.4,22.6 c-24.6,0-46.3-5.1-65.1-15.3c-18.9-10.2-33.6-23.3-44.2-39.4v218.6h-108.7V415H3021v50.2C3031.6,448.7,3046.2,435.4,3064.9,425.2z  M3153.5,527.8c-15-15.5-33.6-23.2-55.6-23.2c-21.6,0-39.9,7.8-55,23.5c-15,15.7-22.6,37.1-22.6,64.2c0,27.1,7.5,48.5,22.6,64.2 c15,15.7,33.4,23.5,55,23.5c21.6,0,40-7.9,55.3-23.8c15.3-15.9,22.9-37.4,22.9-64.5C3176.1,564.6,3168.6,543.3,3153.5,527.8z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M3351.8,361.3c-12.1-11.2-18.1-25.1-18.1-41.6c0-16.9,6-31,18.1-42.3c12.1-11.2,27.6-16.8,46.7-16.8 c18.6,0,34,5.6,46.1,16.8c12.1,11.2,18.1,25.3,18.1,42.3c0,16.5-6,30.4-18.1,41.6c-12.1,11.2-27.4,16.8-46.1,16.8 C3379.4,378.2,3363.9,372.6,3351.8,361.3z M3452.5,415v354.6h-108.7V415H3452.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M3741.1,769.6l-68-98.5l-57.2,98.5h-117.6l116.9-181.1L3495.1,415h122l68,97.9l57.2-97.9h117.6l-118.8,178.6 l122,176H3741.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 458.4074,
    y1: 976.2166,
    x2: 458.4074,
    y2: 66.4905
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#557C93"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#08203E"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M816.4,826.7v6.6v15.8v53.3c0,40.7-33,73.8-73.8,73.8h-69.1H667V826.7H816.4z M572.5,826.7v149.5h-24H305.3 h-41.2h-89.9c-40.7,0-73.8-33-73.8-73.8V140.3c0-40.7,33-73.8,73.8-73.8h568.4c40.7,0,73.8,33,73.8,73.8v254.2v174.1v139.8v24H667 V582.9h-94.4v149.5H423.1v94.3H572.5z M212.1,289.9h436.3v-84.5H212.1V289.9z M212.1,471.1h274.2v-84.5H212.1V471.1z M378,567.9 H212.1v84.5H378V567.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoMain);
export default __webpack_public_path__ + "static/media/Logo_main.bcac1eea059d425df152b8c8c899838c.svg";
export { ForwardRef as ReactComponent };